import Navbar from "./Navbar";
import Footer from "./Footer";
import FloatingEnquiry from "./FloatingEnquiry";

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
      <FloatingEnquiry />
    </div>
  );
};

export default Layout;
